// Copyright (c) Docugami, Inc. All rights reserved.

import { DgProgressBar } from "components/common/DgProgressBar";
import { dgFontFamily } from "components/common/Fonts";
import { greyText, themeWhite } from "components/shell/presentation/AppStyles";
import { IExplorerStatusItem } from "hooks/ExplorerStatus";
import { useMemo } from "react";
import styled from "styled-components";

const StatusText = styled.span`
    font-family: ${dgFontFamily};
    font-size: 10px;
    font-weight: 700;
    color: ${greyText};
`;

const Container = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 2px 5px;
    box-sizing: border-box;
    gap: 2px;
    background: ${themeWhite};
`

export interface NavigationItemGroupStatusProps {
    items: IExplorerStatusItem[];
}

export const NavigationItemGroupStatus = (props: NavigationItemGroupStatusProps): JSX.Element | null => {
    const statusItem = useMemo((): IExplorerStatusItem | undefined => props.items[0], [props.items]);

    return !!statusItem ? (
        <Container>
            <StatusText>{statusItem.message.toUpperCase()}</StatusText>
            { !!statusItem.showProgress && <DgProgressBar percentComplete={statusItem.progress} height={4} backgroundColor={themeWhite} /> }
        </Container>
    ) : null;
}
